import type { ComponentItem, Components } from './types';

import { createSafeContext, useSafeContext } from '../../utils/react';

type ComponentId = string;
type StoreDefault = Record<string, any>;

export type ComponentSwitcherContextType<
  CompId extends ComponentId = ComponentId,
  Store extends StoreDefault = StoreDefault,
> = {
  store: {
    get<K extends keyof Store>(key: K): Store[K];
    set<K extends keyof Store>(key: K, value: Store[K]): void;
    clear(): void;
  };
  current: ComponentItem;
  prev?: ComponentItem;
  next?: ComponentItem;
  components: Components;
  actions: {
    reset(): void;
    next(): void;
    prev(): void;
    navigate(name: CompId): void;
    sendUpdate(): void;
  };
};

export const ComponentSwitcherContext = createSafeContext<ComponentSwitcherContextType>();

export function useComponentSwitcher<
  CompId extends ComponentId,
  Store extends StoreDefault,
>() {
  return useSafeContext(ComponentSwitcherContext) as ComponentSwitcherContextType<
    CompId,
    Store
  >;
}
